export function getWaterList(bean) {
  if (!Array.isArray(bean.selectedHouseList)) return null

  const energyConsumption = bean.selectedHouseList.map(o => o.energyConsumption)

  return energyConsumption.map(list =>
    list.find(o => o.meterReadType === 'WATERMETER')
  )
}

function isEmpty(item) {
  return !(item.houseNumber !== '' && item.meterReadNumber !== '')
}

/**
 * @param {any[]} configList
 */
export function isRequired(configList) {
  let item;
  console.log(configList instanceof Array, 'boolean');
  if (configList instanceof Array) {
    item = configList.find(o => o.chargeType === 'COLDWATERBILL')
  }
  console.log(item, 'item', configList)
  if (!item) return false

  console.log({ item })
  return item.createBillEnum === 'N' && item.unitType === 'TON'
}

// 能耗费收费逻辑优化
export function validateWater() {
  console.log(this.opts)
  console.log(this.businessFormData)

  /** @type {any[]} */
  const itemList = getWaterList(this.businessFormData)
  console.log({ itemList })

  if (itemList === null) return null

  const { energyConfigList } = this.opts
  if (
    itemList.some((item, i) => isRequired(energyConfigList[i]) && isEmpty(item))
  ) {
    return new Error('请录入能耗抄表户号及读数')
  }

  return null
}



// WEBPACK FOOTER //
// ./src/components/forms/BusinessContractForm/free.js